import React from 'react';

export interface WorkspaceBlockerBannerItem {
  title: string;
  description?: string | null;
  actionLabel?: string;
  onAction?: () => void;
}

interface WorkspaceBlockerBannerProps {
  title: string;
  items: WorkspaceBlockerBannerItem[];
}

/**
 * Alerta isolado para condição de bloqueio (ex.: "Instituição bloqueada"). Visualmente
 * diferente de propósito de uma `WorkspaceSection`: não é fila para triar, é portão —
 * borda vermelha mais grossa, sem badge de contagem nem botão de ação.
 */
const WorkspaceBlockerBanner: React.FC<WorkspaceBlockerBannerProps> = ({ title, items }) => {
  if (items.length === 0) return null;
  return (
    <div className="overflow-hidden rounded-lg border-2 border-red-300 bg-red-50 dark:border-red-500/60 dark:bg-red-950/20">
      <div className="border-b border-red-200 bg-red-100/60 px-5 py-3 dark:border-red-500/40 dark:bg-red-950/30">
        <h2 className="text-sm font-semibold text-red-900 dark:text-red-100">{title}</h2>
      </div>
      <div className="divide-y divide-red-100 px-5 py-3 dark:divide-red-900/40">
        {items.map((item, index) => (
          <div key={`${item.title}-${index}`} className="py-2">
            <p className="text-sm font-semibold text-red-900 dark:text-red-100">{item.title}</p>
            {item.description && (
              <p className="mt-0.5 whitespace-pre-wrap text-sm text-red-700 dark:text-red-300">{item.description}</p>
            )}
            {item.onAction && (
              <button
                type="button"
                onClick={item.onAction}
                className="mt-2 rounded-lg border border-red-300 bg-white px-3 py-1.5 text-xs font-semibold text-red-800 hover:bg-red-100 dark:border-red-700 dark:bg-slate-900 dark:text-red-200 dark:hover:bg-red-950/40"
              >
                {item.actionLabel || 'Abrir'}
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default WorkspaceBlockerBanner;
